/*
 * Copyright (c) 2023 Pegasystems Inc.
 * All rights reserved.
 */

import Utils from '../../../utils/utils';

class Move {
  static execute(target: string, fromIndex: number, toIndex: number, pageReference: string) {
    return {
      target: Utils.buildInstructionPageReference(pageReference, target),
      listMoveToIndex: toIndex,
      listIndex: fromIndex,
      instruction: 'MOVE'
    };
  }
}
export default Move;
